module.exports = __webpack_public_path__ + "static/media/columnSortIcon.880f30a9.svg";